import React, { useEffect, useState } from "react";
import Routes from "./Router";
import "./App.css";
import { Toaster } from "react-hot-toast";
import { ProductProvider } from "./utils/ProductContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PreLoader from "./utils/PreLoader/PreLoader";

const queryClient = new QueryClient();
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const handlePageLoad = () => setLoading(false);

    if (document.readyState === "complete") {
      setLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-center"
        toastOptions={{
          success: {
            duration: 2000,
            style: {
              background: "#fff",
              color: "#000",
              borderBottom: "4px solid yellow",
            },
          },
          error: {
            duration: 2000,
            style: {
              background: "#fff",
              color: "#000",
              borderBottom: "4px solid red",
            },
          },
          custom: {
            duration: 2000,
            style: {
              background: "#fff",
              color: "#000",
              borderBottom: "4px solid blue",
            },
          },
        }}
      />
      {/* Preloader can be used to show loading state */}
      {loading && <PreLoader />}

      {/* <ProductProvider> */}
      <Routes />
      {/* </ProductProvider> */}
    </QueryClientProvider>
  );
}

export default App;
